import { supabase } from '../../core/config/supabase';

export class SocialDataSource {
  async getCounts(userId: string): Promise<{
    followersCount: number;
    followingCount: number;
    friendsCount: number;
  }> {
    // Get followers count
    const { count: followersCount, error: followersError } = await supabase
      .from('follows')
      .select('*', { count: 'exact', head: true })
      .eq('following_id', userId);

    if (followersError) throw new Error(followersError.message);

    // Get following count
    const { count: followingCount, error: followingError } = await supabase
      .from('follows')
      .select('*', { count: 'exact', head: true })
      .eq('follower_id', userId);

    if (followingError) throw new Error(followingError.message);

    // Get friends count
    const { count: friendsCount, error: friendsError } = await supabase
      .from('friendships')
      .select('*', { count: 'exact', head: true })
      .or(`requester_id.eq.${userId},addressee_id.eq.${userId}`)
      .eq('status', 'accepted');

    if (friendsError) throw new Error(friendsError.message);

    return {
      followersCount: followersCount || 0,
      followingCount: followingCount || 0,
      friendsCount: friendsCount || 0,
    };
  }
}
